var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.9998 15.2933C29.9998 27.3336 20.3011 36.3781 16.5011 39.4596C15.6182 40.1755 14.3694 40.18 13.4792 39.4738C9.66591 36.4484 0 27.5697 0 15.2933C0 6.847 6.7157 0 15 0C23.2843 0 30 6.847 30 15.2933H29.9998Z",
    fill: "#FF7351"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.4444 26.6666C20.5809 26.6666 25.5555 21.6919 25.5555 15.5554C25.5555 9.41895 20.5809 4.44434 14.4444 4.44434C8.30787 4.44434 3.33325 9.41895 3.33325 15.5554C3.33325 21.6919 8.30787 26.6666 14.4444 26.6666Z",
    fill: "#583095"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.eaaf24a0ba86e1b8fbecdcdb380f7107.svg";
export { ForwardRef as ReactComponent };